export default __webpack_public_path__ + "static/media/5394665-removebg-preview.97d74b6b.png";